import { useCallback } from "react"
import { toast } from "sonner"
import { useChangeEmailMutation, useGetMeQuery } from "./api"
import { VerificationStatus } from "@/auth"
import { invariant } from "@/utils"
import { useT } from "@/i18n"

export default () => {
  const { t } = useT("auth")
  const [changeEmail] = useChangeEmailMutation()
  const { data: me, isLoading } = useGetMeQuery()

  return useCallback(async () => {
    if (isLoading) {
      return
    }
    invariant(me?.email)
    invariant(me.verificationStatus !== VerificationStatus.Verified)

    await changeEmail({ email: me.email })

    toast.success(t("verificationEmailSent"))
  }, [changeEmail, isLoading, me, t])
}
